// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__2_L67","anim":"Modal_anim__fQPNA","modal":"Modal_modal__238K3","modalAnim":"Modal_modalAnim__2iAcg","closeBtn":"Modal_closeBtn__3coeg"};